import styled from 'styled-components';

export const TagSimple = styled.div<{
  $bg: string;
  $borderColor: string;
  $color: string;
  $textTransform?: string;
}>`
  align-items: center;
  display: inline-flex;
  gap: 4px;
  padding: 2px 5px;
  border-radius: 4px;
  letter-spacing: 0.3px;
  line-height: 16px;
  font-size: 14px;
  font-weight: 400;
  border: 1px solid ${(props) => props.$borderColor};
  border-left-width: 1px;
  color: ${(props) => props.$color};
  background-color: ${(props) => props.$bg};
  text-transform: ${(props) => props.$textTransform};
`;
